export function formatContactPhone(value) {
  const text = String(value || '').trim()
  const digits = text.replace(/\D/g, '')
  const international = text.startsWith('+')
  // Preserva números internacionais sem impor a máscara brasileira.
  if (international && !digits.startsWith('55')) return `+${digits.slice(0, 15)}`
  const brazilCode = international || (digits.startsWith('55') && digits.length > 11)
  const number = (brazilCode ? digits.slice(2) : digits).slice(0, 11)
  const prefix = brazilCode ? '+55 ' : ''
  if (!number) return prefix.trim()
  if (number.length <= 2) return `${prefix}(${number}`
  const subscriber = number.slice(2)
  const split = subscriber.length > 8 ? 5 : 4
  const formatted = subscriber.length > split ? `${subscriber.slice(0, split)}-${subscriber.slice(split)}` : subscriber
  return `${prefix}(${number.slice(0, 2)}) ${formatted}`
}

export const formatContactEmail = (value) => String(value || '').replace(/\s/g, '')
